// ISO 8.7 — Controle de saídas não conformes (#279) + decisão correção × ação
// corretiva e abrangência (#280). Campos-BASE da NC (tabela ncs), editados
// pós-criação via PUT /api/v2/nc/{id}/editar. Vocabulário definido aqui (o
// backend grava String livre, sem enum) e reusado pelo editor + os 2
// relatórios, pra não driftar entre superfícies de render.

// Disposição da saída não conforme (ISO 8.7.1: correção, segregação,
// devolução, suspensão, uso sob concessão).
export const DISPOSICAO_OPCOES = [
  { value: 'retrabalho',     label: 'Retrabalho (corrigir para atender ao requisito)' },
  { value: 'reparo',         label: 'Reparo (corrigir parcialmente — aceito)' },
  { value: 'refugo',         label: 'Refugo / sucata (descarte)' },
  { value: 'concessao',      label: 'Concessão (desvio autorizado — cliente/qualidade)' },
  { value: 'uso_como_esta',  label: 'Uso como está (sem alteração)' },
  { value: 'reclassificacao', label: 'Reclassificação (usar para outro fim)' },
  { value: 'devolucao',      label: 'Devolução ao fornecedor' },
];

const DISPOSICAO_LABELS = Object.fromEntries(DISPOSICAO_OPCOES.map((o) => [o.value, o.label]));

// Rótulo de exibição; fallback no valor cru (NCs com valor legado/desconhecido).
export function labelDisposicao(v) {
  if (!v) return null;
  return DISPOSICAO_LABELS[v] || v;
}

// 'sim'/'nao' → 'Sim'/'Não'; qualquer outra coisa (null/vazio) → null (omite).
export function labelSimNao(v) {
  if (v === 'sim') return 'Sim';
  if (v === 'nao') return 'Não';
  return null;
}
